module.exports = __webpack_public_path__ + "static/gotowy_produkt-ba13a120bc9cf057f4f22d02ab5b6501.png";